// Shared letterhead content for InvoicePrint.jsx and QuotationPrint.jsx — placeholder
// text pulled from the clinic's own letterhead sample; the user said the exact text may
// be refined later, so it's centralized here rather than duplicated per print view.
export const CLINIC_INFO = {
  logo: "/assets/img/logo.png",
  clinicName: "ZAHN DENTOFACIAL",
  tagline: "DENTAL & MAXILLOFACIAL CENTRE",
  strapline: "max your happiness",
  addressLines: ["Vandipetta, West Nadakkavu,", "Kozhikode - 673011"],
  phones: ["+91 8848318616", "+91 8281010604"],
  website: "www.zahndentalcare.com",
  doctors: [
    {
      name: "Dr. Nikhil O Govindan",
      qualifications: ["MDS (Oral & Maxillofacial Surgery)", "Fellow Cleft lip and Palate Surgery"],
    },
    {
      name: "Dr. Rekha Nikhil",
      qualifications: ["MDS (Prosthodontics & Implantology)"],
    },
  ],
};
